import { ReviewItem } from '@/types/api';
import { Button } from '@/components/atoms/NewPcButton';

import useCopy from '@/hooks/useCopy';

import CopyIcon from '@/assets/icons/OrderDetails/eva_copy-outline.svg?react';
import MARKET_GUIDE_DATA from '@/contents/marketGuide';

import ExternalIcon from '@/assets/icons/OrderDetails/external-link-fill.svg?react';

import GenerateAnswer from './GenerateAnswer';
import SubmitButton from './SubmitButton';
import SelectTemplate from './SelectTemplate';

export interface AnswerControllerProps {
  comment: string;
  setComment?: (comment: string) => void; // Optional for AutoResizeTextarea
  review: ReviewItem;
  handleRegister: () => void; // Optional for SubmitButton
  isLoading?: boolean; // Optional for SubmitButton
}

const AnswerController = ({
  comment,
  setComment,
  review,
  handleRegister,
  isLoading,
}: AnswerControllerProps) => {
  const isUnanswerable = !review.IsMarketCommentEnable;
  const { copyToClipboard } = useCopy({
    toastMessage: '복사가 완료되었습니다',
  });
  console.log(review);
  const getSellerPageUrl = (marketNameEnglish: string) => {
    const marketData = MARKET_GUIDE_DATA[marketNameEnglish];
    if (!marketData) return null;
    // linkGuide 타입을 찾아서 linkUrl 반환
    const linkGuide = marketData.find(
      (entry) =>
        entry.type === 'linkGuide' &&
        typeof (entry as any).contents === 'object' &&
        (entry as any).contents.linkUrl,
    );
    return (linkGuide && (linkGuide as any).contents.linkUrl) || null;
  };

  // 컴포넌트 내에서
  const handleNavigateToSeller = () => {
    const url = getSellerPageUrl(review.MarketNameEnglish);
    if (url) {
      window.open(url, '_blank');
    } else {
      // fallback: smartstore 등 직접 패턴 생성
      if (review.MarketNameEnglish === 'smartstore') {
        window.open(`https://smartstore.naver.com/`, '_blank');
      } else if (review.MarketNameEnglish === 'cafe24') {
        window.open(`https://eclogin.cafe24.com/Shop/`, '_blank');
      } else {
        // 없는 경우 안내
        alert('판매자 페이지 링크를 찾을 수 없습니다.');
      }
    }
  };

  return (
    <div className="flex items-start justify-between ">
      <div className="flex items-start gap-[8px]">
        <GenerateAnswer review={review} setComment={setComment} />
        <SelectTemplate setComment={setComment} />
        <Button
          onClick={() => copyToClipboard(comment)}
          variant="secondary"
          className=" p-[7px] disabled:text-gr-400"
          disabled={!comment}
        >
          <CopyIcon />
        </Button>
      </div>

      {isUnanswerable ? (
        <Button
          onClick={handleNavigateToSeller}
          variant="secondary"
          size="xsmall"
          className="flex  items-center gap-[6px]"
        >
          판매자 페이지
          <ExternalIcon />
        </Button>
      ) : (
        <SubmitButton handleRegister={handleRegister} isLoading={isLoading} comment={comment} />
      )}
    </div>
  );
};

export default AnswerController;
